import { toast } from "react-toastify";
import "./ErrorToast.css";

const ErrorToast = (message) => toast.error(message, {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
});

export default ErrorToast;